import React, { Component } from "react";
import { Link } from "react-router-dom";
import withStyles from "@material-ui/core/styles/withStyles";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";

//redux stuff
import { connect } from "react-redux";
import { signupUser } from "../redux/actions/userActions";

//MUI stuff
import Grid from "@material-ui/core/Grid";
const styles = {
  form: {
    textAlign: "center",
  },
  image: {
    margin: "20px auto 20px auto",
  },
  pageTitle: {
    margin: "20px auto 20px auto",
  },
  textField: {
    margin: "10px auto 10px auto",
  },
  button: {
    marginTop: "20px",
    marginBottom: "20px",
    position: "relative",
  },
  customError: {
    color: "red",
    fontsize: "10px",
  },
  progress: {
    position: "absolute",
  },
};

class signup extends Component {
  constructor() {
    super();
    this.state = {
      email: "",
      password: "",
      confirmPassword: "",
      handle: "",
      firstName: "",
      lastName: "",
      collegeName: "",
      streamName: "",
      startingYear: "",
      endingYear: "",
      enrollmentNo: "",
      userType: "",
      errors: {},
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.UI.errors) {
      this.setState({ errors: nextProps.UI.errors });
    }
  }

  handlesubmit = (event) => {
    event.preventDefault();
    this.setState({
      loading: true,
    });
    const newUserData = {
      email: this.state.email,
      password: this.state.password,
      confirmPassword: this.state.confirmPassword,
      handle: this.state.handle,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      collegeName: this.state.collegeName,
      streamName: this.state.streamName,
      startingYear: this.state.startingYear,
      endingYear: this.state.endingYear,
      enrollmentNo: this.state.enrollmentNo,
      userType: this.state.userType,
    };
    this.props.signupUser(newUserData, this.props.history);
  };

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };
  render() {
    const {
      classes,
      UI: { loading },
    } = this.props;
    const { errors } = this.state;
    return (
      <Grid container justify="center" className={classes.form}>
        <Grid item xs={10} sm></Grid>
        <Grid item xs={10} sm>
          <h2>ICON</h2>
          {/* <img src={} alt="icon" className={classes.image} /> */}
          <Typography variant="h2" className={classes.pageTitle}>
            SignUp{" "}
          </Typography>
          <form noValidate onSubmit={this.handlesubmit}>
            <TextField
              id="email"
              name="email"
              type="email"
              label="Email"
              className={classes.textField}
              helperText={errors.email}
              error={errors.email ? true : false}
              value={this.state.email}
              onChange={this.handleChange}
              fullWidth
            ></TextField>
            <TextField
              id="password"
              name="password"
              type="password"
              label="Password"
              className={classes.textField}
              helperText={errors.password}
              error={errors.password ? true : false}
              value={this.state.password}
              onChange={this.handleChange}
              fullWidth
            ></TextField>
            <TextField
              id="confirmPassword"
              name="confirmPassword"
              type="password"
              label="Confirm Password"
              className={classes.textField}
              helperText={errors.confirmPassword}
              error={errors.confirmPassword ? true : false}
              value={this.state.confirmpassword}
              onChange={this.handleChange}
              fullWidth
            ></TextField>
            <TextField
              id="handle"
              name="handle"
              type="text"
              label="Handle"
              className={classes.textField}
              helperText={errors.handle}
              error={errors.handle ? true : false}
              value={this.state.handle}
              onChange={this.handleChange}
              fullWidth
            ></TextField>
            <TextField
              id="firstName"
              name="firstName"
              type="text"
              label="First Name"
              className={classes.textField}
              helperText={errors.firstName}
              error={errors.firstName ? true : false}
              value={this.state.firstName}
              onChange={this.handleChange}
              fullWidth
            ></TextField>
            <TextField
              id="lastName"
              name="lastName"
              type="text"
              label="Last Name"
              className={classes.textField}
              helperText={errors.lastName}
              error={errors.lastName ? true : false}
              value={this.state.lastName}
              onChange={this.handleChange}
              fullWidth
            ></TextField>
            <FormControl
              helperText={errors.collegeName}
              className={(classes.formControl, classes.textField)}
              error={errors.collegeName ? true : false}
              fullWidth
            >
              <InputLabel
                // name="collegeName"
                // id="collegeName"
                label="collegeName"
              >
                College Name
              </InputLabel>
              <Select
                native
                value={this.state.collegeName}
                onChange={this.handleChange}
                inputProps={{
                  name: "collegeName",
                  id: "collegeName",
                  type: "text",
                }}
              >
                <option aria-label="None" value="" />
                <option value="HMRITM">HMRITM</option>
              </Select>
            </FormControl>
            <TextField
              id="streamName"
              name="streamName"
              type="text"
              label="Stream Name"
              className={classes.textField}
              helperText={errors.streamName}
              error={errors.streamName ? true : false}
              value={this.state.streamName}
              onChange={this.handleChange}
              fullWidth
            ></TextField>
            <TextField
              id="startingYear"
              name="startingYear"
              type="number"
              label="Starting Year"
              className={classes.textField}
              helperText={errors.startingYear}
              error={errors.startingYear ? true : false}
              value={this.state.startingYear}
              onChange={this.handleChange}
              fullWidth
            ></TextField>
            <TextField
              id="endingYear"
              name="endingYear"
              type="number"
              label="Ending Year"
              className={classes.textField}
              helperText={errors.endingYear}
              error={errors.endingYear ? true : false}
              value={this.state.endingYear}
              onChange={this.handleChange}
              fullWidth
            ></TextField>
            <TextField
              id="enrollmentNo"
              name="enrollmentNo"
              type="number"
              label="Enrollment Number"
              className={classes.textField}
              helperText={errors.enrollmentNo}
              error={errors.enrollmentNo ? true : false}
              value={this.state.enrollmentNo}
              onChange={this.handleChange}
              fullWidth
            ></TextField>
            <FormControl
              helperText={errors.userType}
              className={(classes.formControl, classes.textField)}
              error={errors.userType ? true : false}
              fullWidth
            >
              <InputLabel
                // name="collegeName"
                // id="collegeName"
                label="userType"
              >
                User Type
              </InputLabel>
              <Select
                native
                value={this.state.userType}
                onChange={this.handleChange}
                inputProps={{
                  name: "userType",
                  id: "userType",
                  type: "text",
                }}
              >
                <option aria-label="None" value="" />
                <option value="0">Core Society Member</option>
                <option value="0">Student</option>
              </Select>
            </FormControl>

            {errors.general && (
              <Typography varient="body2" className={classes.customError}>
                {errors.general}
              </Typography>
            )}
            <Button
              type="submit"
              variant="contained"
              color="secondary"
              className={classes.button}
              disabled={loading}
            >
              SignUp{" "}
              {loading && (
                <CircularProgress
                  size={30}
                  className="classes.progress"
                ></CircularProgress>
              )}
            </Button>
            <br />
            <small>
              Already have an account ? login <Link to="/login">here</Link>
            </small>
          </form>
        </Grid>
        <Grid item sm></Grid>
      </Grid>
    );
  }
}

signup.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  UI: PropTypes.object.isRequired,
  signupUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
  UI: state.UI,
});

export default connect(mapStateToProps, { signupUser })(
  withStyles(styles)(signup)
);
